export enum NodeType {
  CONNECTION = 'CONNECTION',
  ANCHOR = 'ANCHOR',
  SEGMENT_NODE = 'SEGMENT_NODE',
}
